//#region \0@oxc-project+runtime@0.142.0/helpers/esm/extends.js
function e() {
	return e = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, e.apply(null, arguments);
}
//#endregion
export { e as default };
